interface LogoProps {
  /** 'light' = sobre fondo oscuro (hero), 'dark' = sobre fondo blanco */
  variant?: 'light' | 'dark';
}

export default function Logo({ variant = 'dark' }: LogoProps) {
  const isLight = variant === 'light';

  return (
    <div className="flex items-center gap-2.5">
      {/* Icon mark */}
      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#3D9E8C] flex-shrink-0">
        <i className="ri-scales-line text-white text-[17px]" />
      </div>

      {/* Wordmark */}
      <div className="flex flex-col leading-none gap-[3px]">
        <span
          className={`font-bold text-[17px] tracking-tight transition-colors duration-300 ${
            isLight ? 'text-white' : 'text-[#1B3A5C]'
          }`}
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Mediatio
        </span>
        <span
          className={`text-[9.5px] font-semibold tracking-[0.22em] uppercase transition-colors duration-300 ${
            isLight ? 'text-white/65' : 'text-[#3D9E8C]'
          }`}
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Global
        </span>
      </div>
    </div>
  );
}
